var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDemoPause = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4469 40.2235C80.4469 62.4383 62.4383 80.4469 40.2235 80.4469C18.0087 80.4469 0 62.4383 0 40.2235C0 18.0087 18.0087 0 40.2235 0C62.4383 0 80.4469 18.0087 80.4469 40.2235Z",
    fill: "#FAC300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22H35.9091V58H25V22Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0909 22H55V58H44.0909V22Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDemoPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/demo-pause.ae1031c13cd9be4a3eab892045141568.svg";